import { Grid, Divider, Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { ExternalLinkType } from '../../enums';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';
import ModelViewerLine from './ModelViewerLine';
import favicon from '../../../public/images/favicon.ico';

const OfficialLink = ({ officialLinks, model, openExternalLink }) => {
  // console.log('externalRedirectUrl', externalRedirectUrl);
  const [favicon, setFavicon] = useState(null);
  useEffect(() => {
    const fIcon = model.supportingLinks.find((l) => l.linkType === ExternalLinkType.FavIcon);
    if (fIcon) {
      setFavicon(fIcon.url);
    } else {
      setFavicon(favicon);
    }
  }, [model]);
  return (
    <>
      {officialLinks.length > 0 && (
        <Grid container spacing={1}>
          {model?.externalRedirectUrl && <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <Card className="official-link-item">
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ marginTop: '.9rem', paddingRight: '2px' }}>
                  <Avatar alt="external" src={favicon} sx={{ width: '1.5rem', height: '1.5rem' }} />
                </div>{' '}
                <h6>Official Link</h6>
              </div>

              <p className="official-link-url" onClick={openExternalLink}>
                {model?.externalRedirectUrl}
              </p>
            </Card>
          </Grid>}
          {officialLinks.map((o) => (
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Card className="official-link-item">
                <h6>
                  {o.linkType === ExternalLinkType.LinkedIn && <LinkedInIcon color="primary" />}
                  {o.linkType === ExternalLinkType.Facebook && <FacebookIcon color="primary" />}
                  {o.linkType === ExternalLinkType.Twitter && <XIcon />}

                  {o.linkType}
                </h6>
                <p
                  className="official-link-url"
                  onClick={() => {
                    window.open(o.url, '_blank');
                  }}
                >
                  {o.url}
                </p>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default OfficialLink;
